<template>
  <header class="relative flex" :class="{ 'sm:min-h-[calc(100svh-3rem)]': hasImage }">
    <Container
      :indent="hasImage ? 'none' : 'lg-but-on-mobile-default'"
      :class="{ 'lg:grid lg:grid-cols-2': hasImage }"
    >
      <!-- IMAGE -->
      <div
        v-if="hasImage"
        v-animate-in-from-left
        class="relative max-h-[35vh] overflow-hidden rounded-br-100 lg:mr-28 lg:max-h-svh"
      >
        <AppImage
          :alt="useMapAltText(data.image)"
          class="size-full object-cover"
          :style="`object-position: ${data.image.focus_css};`"
          :src="data.image"
          loading="eager"
        />

        <!-- Gradient overlay -->
        <div class="absolute inset-0 gradient pointer-events-none max-lg:hidden" />
      </div>

      <div
        v-animate-children-in-from-bottom
        :class="hasImage ? 'mt-8 px-container lg:px-0 lg:pt-navbar-height md:px-container-lg':`
          mt-16 pt-navbar-height
        `"
        class="mt-[10vh] pb-16 lg:pr-28 max-lg:mt-10 sm:pb-28"
      >
        <!-- TEXT HEADER -->
        <div class="mb-10 flex items-center gap-x-8 gap-y-4 lg:mb-16">
          <!-- BackLink to mount page -->
          <BackLink class="typo-body-lg lg:typo-body-xl" :to="{ path: localePath(`/${route.params.uri[0]}`), query: $route.query }" />
          <!-- Category -->
          <div v-if="data.category" class="w-fit border border-dark px-2 py-1 typo-body-lg">
            {{ data.category?.title }}
          </div>
        </div>

        <!-- TITLE -->
        <h1
          v-if="data.heading"
          class="mb-6 typo-heading-xl sm:mb-10 sm:typo-heading-3xl"
          v-html="data.heading"
        />

        <!-- TEXT -->
        <div
          v-if="data.text"
          class="typo-body-xl sm:typo-body-3xl"
          v-html="data.text"
        />
      </div>
    </Container>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const localePath = useLocalePath()

const hasImage = computed(() => {
  return !!props.data.image
})
</script>

<style scoped>
.gradient {
  background: linear-gradient(180deg,rgba(255, 255, 255, 0.5) 0%, transparent 20%);
}
 </style>
